import React, { useEffect } from 'react'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './termsandconditions.css'

function CovidTerms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
        <Navigation
            background="theme-color"
            logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
        />

        <div className='terms_and_conditions-content'>
            <h1>The Outlet COVID-19 Guidelines</h1>
            <h2>In reference to the provided MOH COVID-19 guidelines;</h2>
            <p>
                The Outlet provides further guidelines that: as a platform the user accepts the responsibility for making a decision to book or not to book a service provider via the platform in line with any gazette guidelines by the Government of Kenya. The user understands and agrees that the service provider has no employment relationship with the Outlet. <br />
                The Outlet confirms that all necessary communication under Covid-19 regulations have been communicated to both the user and the service provider through their use of the platform. The user and the service provider are responsible for ensuring all safety measures are adhered to when engaging via the platform. <br />
                The user and the service provider both agree that they have no Covid-19 symptoms, nobody in their home is self-isolating, and that social distancing can be maintained. The Outlet will not be liable for any liability or damage that might arise out of the transaction involved, specific to the virus and otherwise contained within our Terms & Conditions. Further, the Outlet, its affiliates and licensors will not be liable for any claim, injury or damage arising in connection with the use of the services. <br />
                Users will be able to book for services via the platform in reference the provided Covid-19 guidelines as prescribed by the Government of Kenya. The liability of requesting for a service via the Platform is purely on the user.  <br />
                Any cancellation of a service (and subsequent fees) due to a service provider being unable to provide a service based on the provided guidelines by the government of Kenya will be charged to the user. Any fine served by authorities as a result of incorrect or dishonest booking via The Outlet Platform will be charged to the user. <br />
            </p>
        </div>

        <Footer />
    </div>
  )
}

export default CovidTerms